var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViajira(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4686 2.18359H7.70508C7.70508 2.87355 7.97916 3.53526 8.46704 4.02313C8.95492 4.51101 9.61662 4.78509 10.3066 4.78509H11.3686V5.81009C11.369 6.49953 11.643 7.16062 12.1305 7.64813C12.618 8.13564 13.2791 8.4097 13.9686 8.41009V2.68359C13.9686 2.55099 13.9159 2.42381 13.8221 2.33004C13.7284 2.23627 13.6012 2.18359 13.4686 2.18359Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6165 5.05469H4.85352C4.85391 5.74413 5.12797 6.40522 5.61548 6.89273C6.10299 7.38023 6.76407 7.65429 7.45352 7.65469H8.51502V8.68319C8.51581 9.37263 8.79025 10.0336 9.27804 10.5208C9.76583 11.008 10.4271 11.2817 11.1165 11.2817V5.55469C11.1165 5.42208 11.0638 5.2949 10.9701 5.20113C10.8763 5.10737 10.7491 5.05469 10.6165 5.05469Z",
    fill: "url(#paint0_linear_26722_68433)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7635 7.92578H2C1.99993 8.26746 2.06718 8.6058 2.19788 8.92149C2.32859 9.23717 2.52021 9.52402 2.76179 9.76564C3.00336 10.0073 3.29017 10.1989 3.60583 10.3297C3.92149 10.4605 4.25982 10.5278 4.6015 10.5278H5.6665V11.5528C5.6669 12.2417 5.94054 12.9023 6.4274 13.3898C6.91426 13.8772 7.57458 14.1516 8.2635 14.1528V8.42578C8.2635 8.29317 8.21082 8.166 8.11705 8.07223C8.02328 7.97846 7.89611 7.92578 7.7635 7.92578Z",
    fill: "url(#paint1_linear_26722_68433)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26722_68433",
    x1: 9.72152,
    y1: 3.84619,
    x2: 7.28502,
    y2: 6.38869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26722_68433",
    x1: 184.415,
    y1: 171.154,
    x2: 79.7275,
    y2: 274.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViajira);
export default __webpack_public_path__ + "static/media/viajira.89ac73f8f72468c83579b56a01430e70.svg";
export { ForwardRef as ReactComponent };